import { useMutation } from '../';
import { newInvestmentMutation } from '../mutations';

export function useNewInvestmentMutation() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(newInvestmentMutation, variables, (response) => {
      if (onFinish) {
        onFinish(response.newInvestment.id);
      }
    });
  };

  return { data, isLoading, run };
}
